// Initializes the fielstyle plugin
import * as angular from 'angular';

function filestyle() {
    return {
        restrict: 'A',
        link: link
    };

    function link(scope: ng.IScope, $element: JQLite & any) {
        var options = $element.data();
        // old usage support
        options.classInput = $element.data('classinput') || options.classInput;
        $element.filestyle(options);
    }
}

angular.module('app.common').directive('filestyle', filestyle);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/directives/filestyle.directive.ts